module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-04.6918d86e.png";